export default {"src":"/_next/static/media/github.694fb687.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};